import { getCmdbRestBaseUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/index.tsx';
import { useWorkspaceContext } from '@atlassian/jira-servicedesk-insight-common-workspace-context/src/controllers/workspace-context/index.tsx';

/**
 * Helper to get the Insight REST base url including the current workspace ID
 */
export const useCmdbRestBaseUrl = (): string => {
	const { workspaceId } = useWorkspaceContext();
	return getCmdbRestBaseUrl(String(workspaceId));
};
